"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertClazzInCtx = void 0;
const value_1 = require("../value");
function assertClazzInCtx(mod, ctx, value) {
    (0, value_1.assertTypesInCtx)(mod, ctx, value, [
        "ClazzNull",
        "ClazzCons",
        "ClazzFulfilled",
    ]);
}
exports.assertClazzInCtx = assertClazzInCtx;
//# sourceMappingURL=assertClazzInCtx.js.map